import styled from 'styled-components';

export const TabPane = styled.div`
  height: 100%;
  overflow-y: auto;
  flex-grow: 1;
  padding: 10px 10px 59px;
  position: relative;
  scroll-behavior: smooth;
`;

export const Footer = styled.div`
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.04);
  height: 59px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    text-align: center;
  }
`;
